module.exports = __webpack_public_path__ + "img/Avatar-8.0aeaba86.gif";